var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{ref:"ele",class:_vm.css,attrs:{"item-text":"label","item-value":"value","items":_vm.users,"outlined":_vm.outlined,"dense":_vm.dense},on:{"change":function($event){return _vm.listOnSelect($event)}},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }